import screenfull from "screenfull";

const devicesMixin = {
    computed: {
        isMobile() {
            const isAndroid = /Android/i.test(navigator.userAgent);
            const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            const isIpad = (/iPad/i.test(navigator.platform)
                || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document));
            return isAndroid || isiOS || isIpad;
        },
        isIpad() {
            return (/iPad/i.test(navigator.platform)
                || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document));
        },
        isIOS() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        },
        isWebView() {
            return /WebView/.test(navigator.userAgent);
        },
        canNotAutoplay() {
            const isAndroid = /Android/i.test(navigator.userAgent);
            return isAndroid || this.isIpad || this.isIOS || this.isWebView;
        },
        isFullscreen(){
            return screenfull.isFullscreen
        }
    },
    methods: {
        enterFullscreen() {
            try {
                if (screenfull.isEnabled) {
                    if (!screenfull.isFullscreen) {
                        screenfull.request().then(()=>{
                            this._computedWatchers.isFullscreen.run();
                        });
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        exitFullscreen() {
            try {
                if (screenfull.isEnabled) {
                    if (screenfull.isFullscreen) {
                        screenfull.exit().then(()=>{
                            this._computedWatchers.isFullscreen.run();
                        });
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }
};

export {
    devicesMixin
}